import { Outlet } from 'react-router-dom';

import { TCustomRouteObject } from '@/shared/types/router.types';

export const generalSettingsRoutes: TCustomRouteObject = {
  path: '/general-settings',
  Component: () => <Outlet />,
  handle: {
    crumb: {
      label: 'general-settings',
      localized: true,
    },
  },
  children: [
    {
      index: true,
      lazy: async () => {
        const { GeneralSettingsRoute } = await import('./general-settings');
        return { Component: GeneralSettingsRoute };
      },
    },
    {
      path: 'manage-company',
      lazy: async () => {
        const { ManageCompanyRoute } = await import('./manage-company');
        return { Component: ManageCompanyRoute };
      },
      handle: {
        crumb: {
          label: 'manage_company',
          localized: true,
        },
      },
    },
    {
      path: 'webhooks',
      lazy: async () => {
        const { WebhooksRoute } = await import('./webhooks');
        return { Component: WebhooksRoute };
      },
      handle: {
        crumb: {
          label: 'webhooks',
          localized: true,
        },
      },
    },
    {
      path: 'integrations',
      lazy: async () => {
        const { IntegrationsRoute } = await import('./integrations');
        return { Component: IntegrationsRoute };
      },
      handle: {
        crumb: {
          label: 'integrations',
          localized: true,
        },
      },
    },
    {
      path: 'tags',
      lazy: async () => {
        const { TagsRoute } = await import('./tags');
        return { Component: TagsRoute };
      },
      handle: {
        crumb: {
          label: 'tags',
          localized: true,
        },
      },
    },
    {
      path: 'backup-lifecycle',
      lazy: async () => {
        const { BackupLifecycleRoute } = await import('./backup-lifecycle');
        return { Component: BackupLifecycleRoute };
      },
      handle: {
        crumb: {
          label: 'backup_lifecycle',
          localized: true,
        },
      },
    },
    {
      path: 'ideaas',
      lazy: async () => {
        const { IdeaasSettingsRoute } = await import('./ideaas');
        return { Component: IdeaasSettingsRoute };
      },
      handle: {
        crumb: {
          label: 'ideaas_hub_settings',
          localized: true,
        },
      },
    },
    {
      path: 'subscription/:tabId?',
      lazy: async () => {
        const { SubscriptionRoute } = await import('./subscription');
        return { Component: SubscriptionRoute };
      },
      handle: {
        crumb: {
          label: 'subscription',
          localized: true,
        },
      },
    },
  ],
};
